import { Building } from "../Building";
import { PeakBoxTrim } from "./PeakBoxTrim";
import { AddonManager } from "../../scene/addon/AddonManager";
import { RidgeRollTrim } from "./RidgeRollTrim";
import { CornerTrim } from "./CornerTrim";
import { SideColumns } from "./SideColumns";
import { RoofSideTrim } from "./RoofSideTrim";
import { Main } from "../../Main";

/**
 * Manages all the trims.
 */
export class BuildingTrim
{

	private _building : Building;

	private _peakBoxTrim   : PeakBoxTrim;
	private _ridgeRollTrim : RidgeRollTrim;
	private _cornerTrim    : CornerTrim;
	private _sideColumns   : SideColumns;

	private _leftRoofTrim  : RoofSideTrim;
	private _rightRoofTrim : RoofSideTrim;

	constructor(building:Building)
	{
		this._building = building;

		this.init();
	}

	private init()
	{
		var pitch = this._building.config.building.pitch;

		this._peakBoxTrim   = new PeakBoxTrim(this._building);
		this._ridgeRollTrim = new RidgeRollTrim(this._building);
		this._cornerTrim    = new CornerTrim(this._building);
		this._sideColumns   = new SideColumns(this._building);

		this._leftRoofTrim  = new RoofSideTrim({
			parent: this._building.scene3D,
			pitch: pitch,
			side: RoofSideTrim.SIDE_LEFT
		});

		this._rightRoofTrim = new RoofSideTrim({
			parent: this._building.scene3D,
			pitch: pitch,
			side: RoofSideTrim.SIDE_RIGHT
		});

		this._rightRoofTrim.container.rotation.y = Math.PI;


		var leanToConfig = this._building.config.building.leanto;

		leanToConfig.left.drop.signal.add(this.updateRoofTrim);
		leanToConfig.left.enabled.signal.add(this.updateRoofTrim);

		leanToConfig.right.drop.signal.add(this.updateRoofTrim);
		leanToConfig.right.enabled.signal.add(this.updateRoofTrim);

		var insetBayConfig = Main.getInstance().config.building.insetBay;
		insetBayConfig.front.count.signal.add(this.updateRoofTrim);
		//insetBayConfig.front.drop.signal.add(this.updateRoofTrim);
		insetBayConfig.back.count.signal.add(this.updateRoofTrim);
		//insetBayConfig.back.drop.signal.add(this.updateRoofTrim);

		this._building.config.building.propertyChange.add(this.updateRoofTrim);
		this._building.config.building.single_slope.signal.add(this.updateRoofTrim);
		this._building.config.building.gutter.signal.add(this.onGutterChanged);
		this.updateRoofTrim();
	}

	private updateRoofTrim = () =>
	{
		var metrics = this._building.config.metrics;

		var x_left  = -metrics.width_half - metrics.overhang_left;
		var x_right = -metrics.width_half - metrics.overhang_right;
		var y_left  = metrics.height - metrics.overhang_left  *  Math.sin(metrics.alpha);
		var y_right = metrics.height - metrics.overhang_right *  Math.sin(metrics.alpha);

		var length = metrics.length;

		// gutter

		// bottom: ground level
		var leftGutterBottom  = 0.85;
		var rightGutterBottom = 0.85;

		var leanToConfig = this._building.config.building.leanto;

		// gutter is enabled if there's no lean to

		var leftGutterEnabled  = !leanToConfig.left.enabled.value;
		var rightGutterEnabled = !leanToConfig.right.enabled.value;

		this._rightRoofTrim.container.position.z = metrics.overhang_front - metrics.overhang_back;

		var downspoutPadding = metrics.overhang_front + metrics.overhang_back + 1 + 1.4;
		var baseOffset = 0.1;
		var wallOffset_left = metrics.overhang_left - baseOffset;
		var wallOffset_right = metrics.overhang_right - baseOffset;

		var width_left   = metrics.width_half + metrics.overhang_left;
		var width_right  = metrics.width_half + metrics.overhang_right;

		var zBack  = -length/2 - metrics.overhang_back;
		var zFront =  length/2 + metrics.overhang_front;


		// single slope

		var leftPitch = metrics.pitch;
		var rightPitch = metrics.pitch;

		var leftY = y_left;
		var rightY = y_right;

		var single_slope = this._building.config.building.single_slope.value;

		// if (single_slope === "left")
		// {
		// 	leftPitch *= -1;
		// 	leftY += 2 * (width_left * metrics.tan);
		// } else
		if (single_slope)
		{
			rightPitch *= -1;
			rightY += 2 * (width_right * metrics.tan);
		}

		// end of single slope

		var ib = Main.getInstance().config.building.insetBay;
		var insetBayConfig = {front: {count: ib.front.count.value}, back: {count: ib.back.count.value}};

		this._leftRoofTrim.update({
			x: x_left,
			top: leftY,
			width: width_left,
			z_front: zFront,
			z_back: zBack,
			pitch: leftPitch,
			insetBay: insetBayConfig,
			side: "left",
			gutter_enabled: leftGutterEnabled,
			gutter_bottom: leftGutterBottom,
			gutter_length_padding: downspoutPadding,
			gutter_wall_offset: wallOffset_left
		});

		this._rightRoofTrim.update({
			x: x_right,
			top: rightY,
			width: width_right,
			z_front: zFront,
			z_back: zBack,
			pitch: rightPitch,
			insetBay: insetBayConfig,
			side: "right",
			gutter_enabled:rightGutterEnabled,
			gutter_bottom: rightGutterBottom,
			gutter_length_padding: downspoutPadding,
			gutter_wall_offset: wallOffset_right
		});
	};

	private onGutterChanged = () =>
	{
		/*setTimeout(function ()
		{
			Main.getInstance().config.building.width.setValue(Main.getInstance().config.building.width.value - 0.01);
			setTimeout(function ()
			{
				Main.getInstance().config.building.width.setValue(Main.getInstance().config.building.width.value + 0.01);
			}, 0);
		}, 0);*/

		/*setTimeout(() => // this is a workaround for a bug, when some downspouts remain present when there's a leanto and the user turns gutters on
		{
			this.updateRoofTrim();
			Main.getInstance().render = true;
		}, 0);*/

		requestAnimationFrame(() =>
		{
			this.updateRoofTrim();
			Main.getInstance().render = true;
		});
	}
}